import React from "react"
import {
  eventsItemDate,
  eventsItemDateMonth,
  eventsItemDateTo,
  eventsItemDateYear,
  eventsItemTaxo,
  eventsItemTitle,
} from "../agenda.module.scss"
import TransitionFade from "gatsby-theme-blank/src/components/transition-fade"
import {
  dateDayMonthLength,
  dateYearLength,
  dateHourLength,
} from "../../../../constants"
import {
  EventsItemDateTo,
  EventsItemDate,
  EventTitle,
  EventsItemTaxo,
} from "./evenement-content-styled"
import PropTypes from "prop-types"
import { checkHourValue } from "gatsby-theme-blank/src/components/Home/Agenda/utils/check-hour-value"

const EvenementContent = ({ evenement }) => (
  <>
    <EventsItemDate className={eventsItemDate}>
      <span className={eventsItemDateMonth}>
        {evenement.fields.formatted_field_date_de_debut?.slice(
          0,
          dateDayMonthLength
        )}
      </span>
      <span className={eventsItemDateYear}>
        {evenement.field_date_de_debut?.slice(dateYearLength)}
      </span>
      {checkHourValue(evenement.fields.formatted_field_date_de_debut) ? null : (
        <span>
          {evenement.fields.formatted_field_date_de_debut.slice(dateHourLength)}
        </span>
      )}
    </EventsItemDate>
    <EventTitle className={eventsItemTitle}>
      <TransitionFade link={evenement.path.alias}>
        {evenement.title}
      </TransitionFade>
    </EventTitle>
    {evenement.fields.formatted_field_date_de_fin && (
      <EventsItemDateTo className={eventsItemDateTo}>
        Jusqu&apos;au {evenement.fields?.formatted_field_date_de_fin}
      </EventsItemDateTo>
    )}
    {evenement.relationships.field_taxonomie_thematique?.length > 0 && (
      <EventsItemTaxo className={eventsItemTaxo}>
        <span>
          {evenement.relationships.field_taxonomie_thematique[0].name}
        </span>
      </EventsItemTaxo>
    )}
  </>
)

EvenementContent.propTypes = {
  evenement: PropTypes.object.isRequired,
}

export default EvenementContent
